import React, { useState } from "react";
import { Save, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import * as api from "../api";

const COLORI = ["#f6ba00", "#2fa64f", "#8e44ad", "#e0559a", "#1a6fd4", "#0f9d9d", "#5b5bd6", "#e05a33", "#f25c05", "#122a44"];

// Modifica di un singolo account: nome, colore, password, server e porte, protocollo, PEC
export default function EditAccountForm({ account, onSaved, onCancel }) {
  const social = account.tipo === "social";
  const [f, setF] = useState({
    label: account.label || "",
    colore: account.colore || COLORI[0],
    password: "",
    protocollo: account.protocollo || "imap",
    imap_host: account.imap_host || "",
    imap_port: account.imap_port || "",
    smtp_host: account.smtp_host || "",
    smtp_port: account.smtp_port || "",
    is_pec: account.tipo === "pec",
  });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));

  const salva = async () => {
    setSaving(true);
    try {
      const payload = { label: f.label, colore: f.colore };
      if (!social) {
        Object.assign(payload, {
          protocollo: f.protocollo,
          imap_host: f.imap_host,
          imap_port: Number(f.imap_port) || 0,
          smtp_host: f.smtp_host,
          smtp_port: Number(f.smtp_port) || 0,
          is_pec: f.is_pec,
        });
        if (f.password.trim()) payload.password = f.password.trim();
      }
      const acc = await api.updateAccount(account.id, payload);
      toast.success("Account aggiornato");
      onSaved(acc);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Modifica non riuscita");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="edit-acc-form" data-testid={`edit-acc-form-${account.id}`}>
      <div className="edit-acc-row">
        <label className="wf-label">Nome casella</label>
        <input className="wf-input" value={f.label} maxLength={20} onChange={set("label")} placeholder="Es. LAVORO" data-testid="edit-acc-label" />
      </div>
      <div className="edit-acc-row">
        <label className="wf-label">Colore</label>
        <div className="edit-acc-colori">
          {COLORI.map((c) => (
            <button
              key={c}
              type="button"
              className={`editor-colore ${f.colore === c ? "on" : ""}`}
              style={{ background: c }}
              onClick={() => setF((p) => ({ ...p, colore: c }))}
              aria-label={`Colore ${c}`}
              data-testid={`edit-acc-colore-${c.slice(1)}`}
            />
          ))}
        </div>
      </div>
      {!social && (
        <>
          <div className="edit-acc-row">
            <label className="wf-label">Indirizzo</label>
            <input className="wf-input" value={account.email} disabled data-testid="edit-acc-email" />
          </div>
          <div className="edit-acc-row">
            <label className="wf-label">Nuova password</label>
            <input className="wf-input" type="password" value={f.password} onChange={set("password")} placeholder="Lascia vuoto per non cambiarla" autoComplete="new-password" data-testid="edit-acc-password" />
          </div>
          <div className="edit-acc-row">
            <label className="wf-label">Protocollo</label>
            <select className="wf-input" value={f.protocollo} onChange={set("protocollo")} data-testid="edit-acc-protocollo">
              <option value="imap">IMAP</option>
              <option value="pop3">POP3</option>
            </select>
          </div>
          <div className="edit-acc-row edit-acc-server">
            <label className="wf-label">Server in entrata</label>
            <input className="wf-input" value={f.imap_host} onChange={set("imap_host")} placeholder="imap.esempio.it" data-testid="edit-acc-imap-host" />
            <input className="wf-input edit-acc-porta" type="number" value={f.imap_port} onChange={set("imap_port")} placeholder="993" data-testid="edit-acc-imap-port" />
          </div>
          <div className="edit-acc-row edit-acc-server">
            <label className="wf-label">Server SMTP</label>
            <input className="wf-input" value={f.smtp_host} onChange={set("smtp_host")} placeholder="smtp.esempio.it" data-testid="edit-acc-smtp-host" />
            <input className="wf-input edit-acc-porta" type="number" value={f.smtp_port} onChange={set("smtp_port")} placeholder="465" data-testid="edit-acc-smtp-port" />
          </div>
          <label className="edit-acc-check">
            <input type="checkbox" checked={f.is_pec} onChange={set("is_pec")} data-testid="edit-acc-pec" /> Casella PEC
          </label>
        </>
      )}
      <div className="edit-acc-azioni">
        <button className="wf-btn" type="button" onClick={onCancel} disabled={saving} data-testid="edit-acc-cancel">
          <X size={15} strokeWidth={2.6} /> Annulla
        </button>
        <button className="wf-btn primary" type="button" onClick={salva} disabled={saving} data-testid="edit-acc-save">
          {saving ? <Loader2 size={15} className="spin" /> : <Save size={15} strokeWidth={2.4} />} {saving ? "Verifico…" : "Salva"}
        </button>
      </div>
    </div>
  );
}
